import React, {memo} from 'react';

const SaleElement = memo(({label, labelvalue, salePercent, countWindow, id, chkbox, onChangeSale}) => {
	const el_id = `wincalc-rooms-${id}`;
	return (
		<div className="radiobox">
			<input type="radio" name="wincalc-rooms"
				id={el_id}
				defaultChecked={chkbox}
				onChange = {() => onChangeSale(salePercent, countWindow)}
				value = {salePercent}
			/>
			<label htmlFor={el_id}>
				<div className="option-wrapper">
					{label}<span className="option-price"><span>{labelvalue}</span></span>
				</div>
			</label>
		</div>
	)
})

export default SaleElement;